import { render, staticRenderFns } from "./SingleRequest.vue?vue&type=template&id=5b7c8b87&scoped=true&"
import script from "./SingleRequest.vue?vue&type=script&lang=js&"
export * from "./SingleRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7c8b87",
  null
  
)

export default component.exports